import { logger } from '../../../../utils/common/logger'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../adapter'

export class Subscribe extends AbstractWidgetAdapter implements IWidgetAdapter {

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    public loadData(): void {
        logger('info', 'loaded subscription button widget') }
}
